import { Input as BaseInput } from "@base-ui/react/input";
import { cn } from "./cn";

export const inputClasses =
    "h-9 w-full rounded-md border border-border bg-surface px-3 text-sm text-fg " +
    "placeholder:text-muted transition-colors " +
    "focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-accent " +
    "disabled:opacity-50 disabled:cursor-not-allowed " +
    "data-[invalid]:border-red-500";

export type InputProps = React.ComponentPropsWithoutRef<typeof BaseInput>;

/** Themed text input built on Base UI's input primitive (Field-aware). */
export function Input({ className, ...props }: InputProps) {
    return <BaseInput className={cn(inputClasses, className as string)} {...props} />;
}
